module.exports={
	"Form": "ContactCreateManifest",
	"Scope": "Contact-Create",
	"Descriptors":
	{
		"ContactDetails.Title":
		{
			"Name": "Title",
			"Hash": "Contact-Create-Title",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Contact-Create-Identity",
				"Group": "Contact-Create-Identity"
			}
		},
		"ContactDetails.NameFirst":
		{
			"Name": "Name First",
			"Hash": "Contact-Create-NameFirst",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-Create-Details",
				"Group": "Contact-Create-Details"
			}
		},
		"ContactDetails.NameLast":
		{
			"Name": "Name Last",
			"Hash": "Contact-Create-NameLast",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-Create-Details",
				"Group": "Contact-Create-Details"
			}
		},
		"ContactDetails.NameFull":
		{
			"Name": "Name Full",
			"Hash": "Contact-Create-NameFull",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-Create-Details",
				"Group": "Contact-Create-Details"
			}
		},
		"ContactDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Contact-Create-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Contact-Create-Details",
				"Group": "Contact-Create-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"ContactDetails.Email":
		{
			"Name": "Email",
			"Hash": "Contact-Create-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 6,
				"Section": "Contact-Create-Contact",
				"Group": "Contact-Create-Contact"
			}
		},
		"ContactDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "Contact-Create-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Contact-Create-Contact",
				"Group": "Contact-Create-Contact"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Contact-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Contact-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Contact-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Contact-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "Contact-Create-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "Contact-Create-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
